import React from 'react';
import {Box, CardHeader, Divider, FormControl, Grid, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import * as Yup from 'yup';
import {useParams} from 'react-router-dom';
import useAuth from "../../../hooks/useAuth";
import GeneralEditor, {MODE_CREATE, MODE_EDIT} from "../../../components/CrudFrom/GeneralEditor";
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import localStrings from "../../../localStrings";
import {useNavigate} from "react-router";
import {
    addDataEstablishmentToCache,
    createEstablishmentMutation,
    getEstablishmentQuery, updateEstablishmentMutation,
} from "../../../gql/establishmentGql";
import {dashboardBaseRoute} from "../../../routes/dashboard";
import {not_found_path} from "../../../routes";
import GoogleMapsAutocomplete from "../../../components/map/GoogleMapsAutocomplete";
export const getEstablishment = async (brandId, establishmentId, modeEdit, navigate) => {
    if (modeEdit == MODE_CREATE) {
        return null;
    }
    if (!modeEdit || modeEdit == MODE_EDIT) {
        var res =  await executeQueryUtil(getEstablishmentQuery(brandId, establishmentId));
        if (!res.data?.getEstablishment) {
            navigate('/' + not_found_path);
            return;
        }
        return res;
    }
    return null;
}

export const saveFormEstablishment = async (item, values, modeEdit, brandId, navigate) => {
    let data;
    if (!modeEdit || modeEdit == MODE_EDIT) {
        data = {
            ...item,
            ...values,
        };
        await executeMutationUtil(updateEstablishmentMutation(brandId, data));
    }

    else if (modeEdit == MODE_CREATE){
        data = {...values};
        const created = await executeMutationUtil(createEstablishmentMutation(brandId, data));
        await addDataEstablishmentToCache(brandId, [created.data?.addEstablishment]);
        if (navigate) {
            navigate("/" + dashboardBaseRoute + "/establishments/detail/" + created.data?.addEstablishment?.id);
        }
    }


    return data;
}

const EstablishmentCreateUpdateForm = ({className, modeEdit}) => {
    // let {restaurantId} = useParams();
    let {establishmentId} = useParams();
    const config = require('../../../conf/config.json');
    const { currentBrand } = useAuth();
    const navigate = useNavigate();

    const buildFormValues = (item) => {
        return {
            initialValues: {
                name: item.name || '',
                id: item.id,
                address: item.address || '',
                timezone: item.timezone || '',
            },
            validationSchema: {
                name: Yup.string().max(255).required(localStrings.check.fieldRequired),

                // maxItemPerColumn: Yup.number(),
                // changePageDelay: Yup.number(localStrings.check.msFormat).positive(localStrings.check.msFormat)
                //   .required(localStrings.check.fieldRequired),
                // displayMessageDelay: Yup.number(localStrings.check.msFormat).positive(localStrings.check.msFormat)
                //   .required(localStrings.check.fieldRequired)
            }
        };
    }



    const getCardContentForm = ({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                    touched,
                                    values
                                }) => {
        return (
            <Grid
                container
                spacing={4}
            >
                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.name && errors.name}
                        label={localStrings.name}
                        name="name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        required
                        value={values.name}
                    />
                </Grid>




                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <GoogleMapsAutocomplete noKeyKnown
                                            title={values.address || localStrings.address}
                                            setValueCallback={(label, placeId, city, postcode, citycode, lat, lng) => {
                                                console.log("setValueCallback " + label + " " + placeId + " " + city + " " + postcode + " " + citycode + " " + lat + " " + lng);
                                                setFieldValue("address", label);
                                                setFieldValue("placeId", placeId);
                                                setFieldValue("city", city);
                                                setFieldValue("postcode", postcode);
                                                setFieldValue("citycode", citycode);
                                                setFieldValue("lat", lat);
                                                setFieldValue("lng", lng);
                                            }}/>

                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        disabled={true}
                        fullWidth
                        // helperText={touched.timezone && errors.timezone}
                        // label={localStrings.timezone}
                        name="timezone"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        value={values.timezone}
                    />
                </Grid>
            </Grid>
        );
    }




    return <GeneralEditor getItemFunction={() => getEstablishment(currentBrand().id, establishmentId, modeEdit, navigate)}
                          className={className}
                          buildFormValues={buildFormValues}
                          getCardContentForm={getCardContentForm}
                          saveForm={(item, values) => saveFormEstablishment(item, values, modeEdit, currentBrand().id, navigate)}
                          applyButton={modeEdit == MODE_CREATE ? localStrings.create : localStrings.update}
                          resetFormProp={modeEdit == MODE_CREATE}
                          messageSuccess={modeEdit == MODE_CREATE ?
                              localStrings.notif.establishmentCreated : localStrings.notif.establishmentUpdated}
                          titleForm={modeEdit == MODE_CREATE ? localStrings.createEstablishment : localStrings.general}
                          getPathToData={(result) => {
                              return  result.data.getEstablishment;
                          }}
    />
};

export default EstablishmentCreateUpdateForm;
